import { bgcolor, lineHeight, width } from "@mui/system";

const styles = (theme) => ({
	container: {
		display: "flex",
		flexDirection: "column",
		width: "100%",
		gap: 1,
		height: "100%",
	},
	paper: {
		padding: "16px",
		display: "flex",
		flexDirection: "column",
		gap: 1,
		justifyContent: "space-between",
		maxWidth: "100%",
		position: "relative",
		height: "208px",
		borderRadius: "10px",
		overflow: "hidden",
	},
	boxSkeletonChart: {
		display: "flex",
		flexGrow: 1,
		justifyContent: "flex-end",
		pr: 2,
		pl: 5,
	},
	linearProgress: {
		position: "absolute",
		top: 0,
		left: 0,
		width: "100%",
		zIndex: 1,
	},
	chipSpeed: {
		backgroundColor: "chip.main.waitingReview",
		p: 0,
	},
	textChipValue: {
		fontSize: "12px",
		fontWeight: "bold",
		lineHeight: "11px",
		"@media (max-width: 500px)": {
			lineHeight: "10px",
		},
	},
	textChipTitle: {
		fontSize: "10px",
		fontWeight: "bold",
		lineHeight: "11px",
		"@media (max-width: 500px)": {
			lineHeight: "10px",
		},
	},
	boxChipText: {
		display: "flex",
		flexDirection: "column",
		gap: 0.6,
		justifyContent: "center",
	},
	chipIcon: {
		color: theme.palette.white.main,
		fontSize: "20px",
		mt: "-2.5px",
	},
	chipIconContainer: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		p: "4px",
		borderRadius: "50%",
		backgroundColor: theme.palette.cardTrafficData.containerColorIcon.inputData,
	},
	boxSkeletonChipError: {
		display: "flex",
		flexGrow: 1,
		justifyContent: "flex-end",
		borderRadius: "10px",
		width: "91px",
		height: "31px",
	},
	boxSkeletonChipSpeed: {
		display: "flex",
		flexGrow: 1,
		justifyContent: "flex-end",
		borderRadius: "10px",
		width: "132px",
		height: "31px",
	},
	boxChart: {
		display: "flex",
		flexDirection: "column",
		gap: 1,
		height: "100%",
		"@media (max-width: 1100px)": {
			height: "230px",
		},
	},
	boxChipContente: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "space-between",
		gap: 1,
	},
	containerChips: {
		display: "flex",
		flexDirection: "row",
		gap: 4,
		flexWrap: "nowrap",
		"@media (max-width: 500px)": {
			gap: 1,
		},
	},
	graphHeader: {
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-between",
	},
	cardSubText: {
		fontWeight: 500,
		fontSize: "16px",
		mb: 0.4,
		"@media (max-width: 600px)": {
			mb: 0.1,
		},
	},
	boxFilter: {
		display: "flex",
		width: "100%",
		justifyContent: "center",
	},
	percentileText: {
		fontSize: "13px",
		color: "theme.palette.primary.main",
		height: "2px",
		transform: "translateY(-12px)",
	},
	removeIcon: { color: "red", transform: "translateY(6px)" },
});

export default styles;
